import * as React from 'react';
import { Grid } from 'ui-toolkit';
import { ClientUsersContainer } from './ClientUsersContainer';
import { DefaultContactsContainer } from './DefaultContactsContainer';
import { ClientDetailsHeader } from '../../components/clients/ClientDetailsHeader';
import { clientNavigationOptions } from '../../router/admin/ClientLenderCompaniesRouter';
import { useParams } from 'react-router-dom';
import { UUID } from '../../types/shared/UUID';
import { useListClientsQuery } from '../../API/clients/ClientCompanyApi';
import { ErrorMessageTW } from '../../tailwindComponents/errorMessage/ErrorMessageTW';

export const ClientContactsPage: React.FC = () => {
  const { clientId } = useParams<{ clientId: UUID }>();

  const { data: allClients = [], error: fetchError } = useListClientsQuery({ includeDeactivated: true });
  const company = allClients.find((company) => company.id === clientId);

  return (
    <Grid>
      <ErrorMessageTW rtkError={fetchError} />
      <>
        <ClientDetailsHeader
          clientId={clientId}
          companyName={company ? company.name : clientId}
          currentPageLink={clientNavigationOptions(clientId)[0].to || ''}
        />
        <DefaultContactsContainer clientId={clientId} />
        {company && <ClientUsersContainer clientId={clientId} />}
      </>
    </Grid>
  );
};
